import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Field = ({ label, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label className="eyebrow">{label}</Label>
    {children}
  </div>
);

export const OptionSelect = ({ value, onChange, options, placeholder, testId, className = "" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testId} className={`bg-white ${className}`}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {Object.entries(options).map(([k, label]) => (
        <SelectItem key={k} value={k} data-testid={`${testId}-option-${k}`}>{label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
